import axios from 'axios';

export default {
  async downloadPdfOffer(pdfURL,pdfName,pdfData,customerData){
    const pdfContents = await this.getPDF(pdfData, pdfURL, customerData);
    if (pdfContents !== undefined) {
      const blob = this.decryptBytes(pdfContents);
      createDownloadLink(blob, pdfName);
    }
  },
  async getPDF(pdfData, pdfURL, customerData) {
    const headers = {
      headers: {
        'Content-Type': 'application/json',
        'UUID': customerData.uuid,
        'Path': window.location.pathname,
        'Source': customerData.prequalSource.value,
        'LanguageCode': customerData.languageCode
      }
    };

    try {
      const { status, data } = await axios.post(pdfURL, pdfData, headers);
      return status === 200 ? data : undefined;
    } catch {
      return undefined;
    }
  },



decryptBytes(pdfContents) {
  const binaryString = window.atob(pdfContents);
  const binaryLen = binaryString.length;
  const pdfBytes = new Uint8Array(binaryLen);
  for (let i = 0; i < binaryLen; i++) {
    pdfBytes[i] = binaryString.charCodeAt(i);
  }
  return new Blob([pdfBytes]);
}

};


export function createDownloadLink(blob,pdfName) {
  const link = document.createElement('a');
  link.setAttribute('download', pdfName);
  link.href = window.URL.createObjectURL(blob);
  link.click();
}
